
import { useDispatch} from "react-redux";
import { setactiveconfirmuser,set_Acc_InProgress } from '../../slice/mainslice'
import { Loader, Tooltip } from '@mantine/core';
import { Eye,CircleX, Check, FileOff } from 'tabler-icons-react';

//import { setshowsplitdoc } from "../../slice/mainslice";
import intl from "react-intl-universal";
import { notifications } from "@mantine/notifications";


/**
 * Buttons for document reading
 *
 * @param {any} props.meetingParticipantId - CMS User ID
 * @param {any} props.drnId - DRN Meeting ID
 * @param {any} props.userId - DRN User ID
 * @param {any} props.resourceId - Dokumente ID
 * @param {any} props.setreadinorigress() - function um das ausgewählet Dokument zu verwalten
 * @param {any} props.readinorigress - Daten der Dokumente die Vorgelesen werden
 * @return {JSX.Element} the JSX element representing the document reading interface
 */


const DocReadButtons = (props:any ) => {
   const dispatch = useDispatch()
   //const meuser = useSelector((state: any) => state.user.meuser)


  /**
   * Funktion um das Dokument zum Vorlesen auszuwählen.
   */
  const sendopendoc = () => {
    dispatch(setactiveconfirmuser(props.meetingParticipantId))
    const handledocpayload = {
      drnId: props.drnId,
      userId: props.userId,
      resourceId: props.resourceId,
      command: "opendoc"   
    };
  
   dispatch({ type: 'SIGNALR_SENDOPENDOC', payload: handledocpayload });

    props.setreadinorigress({ ...props.readinorigress, view: true, resourceId: props.resourceId })
    dispatch(set_Acc_InProgress("Vorlesung"))
  }
  
  /**
   * Funktion um das  Dokument das zum Vorlesen ausgewählt warzu schließen.
   */
  const sendclosedoc = () => {
    dispatch(setactiveconfirmuser(props.meetingParticipantId))
    // Close Dokument
    const handledocpayload = {
      drnId: props.drnId,
      userId: props.userId,
      resourceId: props.resourceId,
      command: "closedoc"   
    }; 
    
   dispatch({ type: 'SIGNALR_SENDOPENDOC', payload: handledocpayload });

    props.setreadinorigress({ ...props.readinorigress, view: false, resourceId: "" })
    dispatch(set_Acc_InProgress(""))



  }

  /**
   * Generate a signalR to mark a document as read.
   *
   */

  const dochaveread = () => {
        // Sent have Read Sign
        const handlehavereaddoc = {
          drnId: props.drnId,
          resourceId: props.resourceId,
          IsReadOut: true   
      };

      dispatch({ type: 'SIGNALR_SETDOCUMENTISREADOUT', payload: handlehavereaddoc });
      sendclosedoc()

      notifications.show({
        title: intl.get('NOTIF_INFO_HEADER'),
        message: intl.get('NOTIF_READ_OK'),
        withCloseButton: true,
        autoClose: 5000,
      })

   
  }

  /**
   * Generate a signalR to mark a document as not read.
   *
   */
  const dochavenotread = () => {
    // Sent have Read Sign
    const handlenotreaddoc = {
      drnId: props.drnId,
      resourceId: props.resourceId,
      IsReadOut: false   
  };

  dispatch({ type: 'SIGNALR_SETDOCUMENTISREADOUT', payload: handlenotreaddoc });

  notifications.show({
    title: intl.get('NOTIF_INFO_HEADER'),
    message: intl.get('NOTIF_READ_REMOVE'),
    withCloseButton: true,
    autoClose: 5000,
  })


}



   return (
        <>
          {!props.readinorigress.view && 
           <Tooltip label={intl.get('DOCREAD_BUTTON_TT_OPEN')} multiline={true}>
            <span>
            <Eye
                size={38}
                strokeWidth={1}
                onClick={() => sendopendoc()}
                />
              </span>
            </Tooltip>
          }
          {props.readinorigress.view && props.readinorigress.resourceId === props.resourceId && 
          <>
          <Loader color="green" variant="dots" size="sm" />
          {!props.isReadOut &&
           <Tooltip label={intl.get('DOCREAD_BUTTON_TT_READ_DONE')} multiline={true}>
           <span>
          <Check
             size={38}
            strokeWidth={1}
            color={'green'}
            onClick={() => dochaveread()}
          />
           </span>
            </Tooltip>
          }
        {props.isReadOut &&
         <Tooltip label={intl.get('DOCREAD_BUTTON_TT_READ_REVERSE')} multiline={true}>
         <span>
        <FileOff
             size={38}
            strokeWidth={1}
            color={'red'}
            onClick={() => dochavenotread()}
         />
         </span>
         </Tooltip> 
        }
      <Tooltip label={intl.get('DOCREAD_BUTTON_TT_CLOSE')} multiline={true}>
           <span>
          <CircleX
             size={38}
            strokeWidth={1}
            color={'gray'}
            onClick={() => sendclosedoc()}
            
         />
         </span>
         </Tooltip>   
         </>
         }
        </>
    )
};

export default DocReadButtons;